import ResourceLibraryScreen from "../componenets/resourceLibrary/ResourceLibraryScreen";
import recipesConfig from "../componenets/resourceLibrary/recipesConfig";

const RecipesScreen = () => {
  return <ResourceLibraryScreen config={recipesConfig}/>;
};

export default RecipesScreen;
